export default __webpack_public_path__ + "static/media/registration.46e5b127.jpg";